import { normalizeLinks, linksAreValid } from "@/utils/linkLists";
import { CalendarCheck, Info, PhoneCall, ShoppingBag, ShoppingCart, UserPlus } from "lucide-react";

/** Google Business Profile post buttons. All but CALL open a URL; CALL dials the profile's phone. */
export const CALL_TO_ACTIONS = [
  { value: "BOOK", label: "Reservar", icon: CalendarCheck, needsUrl: true },
  { value: "ORDER", label: "Pedir online", icon: ShoppingCart, needsUrl: true },
  { value: "SHOP", label: "Comprar", icon: ShoppingBag, needsUrl: true },
  { value: "LEARN_MORE", label: "Más información", icon: Info, needsUrl: true },
  { value: "SIGN_UP", label: "Registrarse", icon: UserPlus, needsUrl: true },
  { value: "CALL", label: "Llamar ahora", icon: PhoneCall, needsUrl: false },
];

export const NO_CALL_TO_ACTION = { type: "", url: "" };

export const callToActionMeta = (type) => CALL_TO_ACTIONS.find((item) => item.value === type) || null;

/** `{ type, url }` of a saved adaptation. */
export const callToActionOf = (adaptation) => ({
  type: adaptation?.call_to_action || "",
  url: adaptation?.call_to_action_url || "",
});

/** "https://www.tuweb.com/alta" -> "tuweb.com/alta", short enough to sit next to the button label. */
export const callToActionHost = (url) => {
  try {
    const { hostname, pathname } = new URL(url);
    return hostname.replace(/^www\./, "") + (pathname === "/" ? "" : pathname);
  } catch {
    return url || "";
  }
};

/** "ejemplo.com" -> "https://ejemplo.com"; "" when it is not a web address. */
export const normalizeCallToActionUrl = (value) => {
  const [url] = normalizeLinks([value]);
  return url && linksAreValid([url]) ? url : "";
};
